import React, { useRef, useState } from "react";
import * as PropTypes from "prop-types";
import { databasePropType } from "../../../propTypes";
import { defaultAreaId, reportingYear } from "../../../constants";
import AbsoluteChartToggleFrame from "../../widgets/AbsoluteChartToggleFrame";
import AreaChooser from "../../choosers/AreaChooser";
import UsersByMethodChart from "./UsersByMethodChart";

const UsersByMethodChartWidget = props => {
  const [areaId, setAreaId] = useState(defaultAreaId);

  const ref = useRef();

  return (
    <AbsoluteChartToggleFrame
      dataViewerId="users_by_method_chart"
      reference="Figure 2.1"
      title={`Users by Method, ${reportingYear}`}
      subtitle="Comparison by Sector"
      contentWidth={300}
      filters={[
        <AreaChooser
          id="figure-2-1"
          label="Select Country or Country Group"
          areas={props.database.areas}
          includeCountries={true}
          selectedKey={areaId}
          onChange={areaId => {
            setAreaId(areaId);

            props.onChange({
              widget: "theme2.usersByMethodChart",
              payload: {
                areaId
              }
            });
          }}
        />
      ]}
      initialAbsolute={true}
      chartRef={ref}
      chartSettings={{
        area: props.database.areas[areaId].area
      }}
    >
      <UsersByMethodChart
        ref={ref}
        database={props.database}
        areaId={areaId}
        data={props.data}
      />
    </AbsoluteChartToggleFrame>
  );
};

UsersByMethodChartWidget.propTypes = {
  database: databasePropType,
  data: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired
};

export default UsersByMethodChartWidget;
